import * as constants from './constants';

const INITIAL_STATE = {
  unreadMessage: null,
  showBadge: false,
};

const exportedObject = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case constants.SET_UNREAD_MESSAGE:
      return { ...state, unreadMessage: action.payload };
    case constants.SET_SHOW_BADGE:
      return { ...state, showBadge: action.payload };
    default:
      return state;
  }
};

export default exportedObject;
